import { createSelector } from 'reselect'
import isEmpty from 'lodash/isEmpty'

const resultDomain = (state) => state.tasteProfileOnboarding.result
const questionDomain = (state) => state.tasteProfileOnboarding.questions

export const selectHasResult = createSelector(
  resultDomain,
  (result) => !isEmpty(result)
)

export const selectFetchResultFailed = createSelector(
  resultDomain,
  (result) => result.fetchResultFailed
)

export const selectHasAnsweredAllQuestions = createSelector(
  questionDomain,
  (questions) =>
    // Does every question have an answer?
    questions.length > 0 && questions.every((question) => !!question.answered)
)
